import { makeSvgIcon } from '../makeSvgIcon'

export const tower = makeSvgIcon(
  <path d="M5 19C8 19 8 9 5 9V5V2H8V4C8 5.5 10 5.5 10 4V2H14V4C14 5.5 16 5.5 16 4V2H19V5V9C16 9 16 19 19 19V22H5V19Z" />
)
